import xss from 'xss'
import { useCmsStore } from '@/stores/cms'

export default defineNuxtPlugin(() => {
  const cms = (key) => {
    const cmsStore = useCmsStore()
    const [storeKey, valueKey] = key.split('.')

    if (!cmsStore.isInitialized) {
      console.warn('CMS store not initialized when accessing:', key)
      return ''
    }

    if (typeof cmsStore[storeKey] !== 'object') {
      console.warn(`CMS store section "${storeKey}" not found for key:`, key)
      return ''
    }

    const rawText = cmsStore[storeKey][valueKey]
    if (!rawText) {
      console.warn(`CMS value not found for key:`, key)
      return ''
    }

    const whiteList = xss.getDefaultWhiteList()
    whiteList.a = [...whiteList.a, 'class', 'data-popup-page']
    whiteList.iframe = [
      'src',
      'width',
      'height',
      'allow',
      'frameborder',
      'allowfullscreen'
    ]
    return xss(rawText, {
      whiteList
    })
  }

  return {
    provide: {
      cms
    }
  }
})
